export default "__VITE_ASSET__BGxvvLPS__"